import * as ng from 'angular';

ng.module('e360')
   .filter('percent', percentFilterProvider);

percentFilterProvider.$inject = ['numberFilter'];
export function percentFilterProvider(numberFilter) {
   return percentFilter;
   function percentFilter(value:number, fractionSize?:number) {
      if (isFinite(value)) {
         return numberFilter(value * 100, fractionSize) + '%';
      }

      return value;
   }
}
